// extracted by mini-css-extract-plugin
export default {"statusBadge":"statusBadge_statusBadge__zTZNm","active":"statusBadge_active__J5vs0","inactive":"statusBadge_inactive__OxlMs"};